import React, { memo } from 'react';

import { Chip, Stack, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';

import {
  scannedSectionChipStyles,
  scannedSectionsContainerStyles,
} from '../../../ActionStep.styles';

const getShortSource = source => {
  if (source.includes('Fannie') || source.toLowerCase() === 'fnma') {
    return 'FNMA';
  }

  if (source.includes('Freddie') || source.toLowerCase() === 'fhlmc') {
    return 'FHLMC';
  }

  if (source.includes('FHA')) {
    return 'FHA';
  }

  if (source.includes('VA')) {
    return 'VA';
  }

  if (source.includes('USDA')) {
    return 'USDA';
  }

  return source;
};

const ScannedSectionsContent = ({ contentProps }) => {
  const { scannedSections } = contentProps;

  return (
    <Stack sx={scannedSectionsContainerStyles}>
      {scannedSections.map(section => {
        const shortSource = getShortSource(section.source);
        const displayLabel = `${shortSource} §${section.sectionNumber}`;
        const tooltipText = `${section.source} §${section.sectionNumber}`;

        return (
          <Tooltip key={`${section.source}-${section.sectionNumber}`} title={tooltipText}>
            <Chip label={displayLabel} sx={scannedSectionChipStyles} variant="outlined" />
          </Tooltip>
        );
      })}
    </Stack>
  );
};

ScannedSectionsContent.propTypes = {
  contentProps: PropTypes.shape({
    scannedSections: PropTypes.arrayOf(
      PropTypes.shape({
        source: PropTypes.string.isRequired,
        sectionNumber: PropTypes.string.isRequired,
      }),
    ).isRequired,
  }).isRequired,
};

export default memo(ScannedSectionsContent);
